import { render, staticRenderFns } from "./tabZujianChild3.vue?vue&type=template&id=32c66af9&"
import script from "./tabZujianChild3.vue?vue&type=script&lang=js&"
export * from "./tabZujianChild3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tabZujianChild3.vue"
export default component.exports